import React from 'react';
import { motion } from 'framer-motion';
import { testimonials } from '../data/siteContent';

const Testimonials = () => {
  return (
    <section className="testimonials-section">
      <div className="container">
        <span className="section-kicker">Patient trust</span>
        <h2 className="section-title">Testimonials & Real Patient Media</h2>
        <p className="testimonial-intro">
          Real visuals, real voices, and simple Hindi-friendly communication are a big part of why families
          stay connected with this care journey.
        </p>
        <div className="testimonials-grid professional-testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={testimonial.id}
              className={`testimonial-card testimonial-card-${testimonial.type}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.5 }}
            >
              {testimonial.type === 'video' ? (
                <div className="testimonial-media">
                  <video controls preload="metadata" poster={testimonial.poster}>
                    <source src={testimonial.src} type="video/mp4" />
                  </video>
                </div>
              ) : (
                <div className="testimonial-photo-wrap">
                  <img src={testimonial.image} alt={testimonial.name} className="testimonial-photo" />
                </div>
              )}
              <div className="testimonial-body">
                <div className="testimonial-icon">"</div>
                <p className="testimonial-message">{testimonial.quote}</p>
                <div className="testimonial-author">
                  <h4>{testimonial.name}</h4>
                  <span>{testimonial.location}</span>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
